<script setup lang="ts">
import { withDefaults } from 'vue'

import Loading from '@material-symbols/svg-400/rounded/progress_activity.svg'
import Diagnosis from '@material-symbols/svg-400/rounded/diagnosis.svg'

const props = withDefaults(
  defineProps<{
    loading: boolean
  }>(),
  { loading: false }
)

</script>
<template>
  <button class="btn-next py-2 px-4" type="submit">
    <slot />
    <Loading v-if="props.loading" class="animate-spin w-6 h-6 ml-2" />
    <Diagnosis v-if="!props.loading" class="w-6 h-6 ml-2" />
  </button>
</template>

